(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPickerImageNames extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this._scheduled = false;
      this._frame = null;
      this.optionData = this.readOptionData();

      this.addEventListener('change', () => this.scheduleSync());
      this.addEventListener('click', () => this.scheduleSync());

      this._observer = new MutationObserver(() => this.scheduleSync());
      this._observer.observe(this, {
        childList: true,
        subtree: true,
      });

      this.scheduleSync();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._frame) cancelAnimationFrame(this._frame);
    }

    scheduleSync() {
      if (this._scheduled) return;
      this._scheduled = true;

      this._frame = requestAnimationFrame(() => {
        this._scheduled = false;
        this._frame = null;
        this.syncNames();
      });
    }

    syncNames() {
      const labels = this.getImageLabels();
      this.markResponsiveGroups(labels);

      labels.forEach((label, labelIndex) => {
        const input = this.findInput(label);
        const variantName = this.findVariantName(label, input, labelIndex, labels);

        label.dataset.variantSelected = input && input.checked ? 'true' : 'false';

        if (!variantName) return;

        let nameElement = label.querySelector('.variant-option__image-name');

        if (!nameElement) {
          nameElement = document.createElement('span');
          nameElement.className = 'variant-option__image-name';
          label.appendChild(nameElement);
        }

        if (nameElement.textContent !== variantName) {
          nameElement.textContent = variantName;
        }

        const themeText = label.querySelector('.variant-option__button-label__text');
        if (themeText && themeText !== nameElement) {
          themeText.classList.add('variant-option__button-label__text--name-source');
          nameElement.setAttribute('aria-hidden', 'true');
        } else {
          nameElement.removeAttribute('aria-hidden');
        }
      });
    }

    readOptionData() {
      const dataElement = this.querySelector('[data-variant-option-data]');
      if (!dataElement) return [];

      try {
        const optionData = JSON.parse(dataElement.textContent);
        return Array.isArray(optionData) ? optionData : [];
      } catch (error) {
        return [];
      }
    }

    getImageLabels() {
      const labels = new Set(
        this.querySelectorAll('.variant-option__button-label--image')
      );

      this.querySelectorAll('.variant-option__button-label__image').forEach((imageBox) => {
        const owner = imageBox.closest(
          'label, button, [role="radio"], .variant-option__button-label'
        );

        if (owner && this.contains(owner)) {
          owner.classList.add('variant-option__button-label--image');
          labels.add(owner);
        }
      });

      return Array.from(labels);
    }

    findGroup(label) {
      const fieldset = label.closest('fieldset, .product-form__input');
      if (fieldset) return fieldset;

      const variantOption = label.closest('.variant-option, [data-option-position]');
      if (variantOption) {
        const imageCount = variantOption.querySelectorAll(
          '.variant-option__button-label__image'
        ).length;

        return imageCount > 1 ? variantOption : variantOption.parentElement;
      }

      return label.parentElement;
    }

    markResponsiveGroups(labels) {
      labels.forEach((label) => {
        const group = this.findGroup(label);
        if (!group || !this.contains(group)) return;

        group.dataset.variantImageGroup = 'true';

        const itemWrapper = label.parentElement;
        if (!itemWrapper || itemWrapper === group) return;

        const wrapperImageCount = itemWrapper.querySelectorAll(
          '.variant-option__button-label__image'
        ).length;

        if (wrapperImageCount === 1) {
          itemWrapper.dataset.variantImageItem = 'true';
        }
      });
    }

    findInput(label) {
      if (label.control instanceof HTMLInputElement) return label.control;

      const inputInside = label.querySelector('input[type="radio"], input[type="checkbox"]');
      if (inputInside) return inputInside;

      const forId = label.getAttribute('for');
      if (forId) {
        const linkedInput = label.ownerDocument.getElementById(forId);
        if (linkedInput instanceof HTMLInputElement) return linkedInput;
      }

      let sibling = label.previousElementSibling;
      let checkedSiblings = 0;

      while (sibling && checkedSiblings < 3) {
        if (sibling.matches('input[type="radio"], input[type="checkbox"]')) return sibling;
        sibling = sibling.previousElementSibling;
        checkedSiblings += 1;
      }

      sibling = label.nextElementSibling;
      checkedSiblings = 0;

      while (sibling && checkedSiblings < 3) {
        if (sibling.matches('input[type="radio"], input[type="checkbox"]')) return sibling;
        sibling = sibling.nextElementSibling;
        checkedSiblings += 1;
      }

      const optionWrapper = label.closest('.variant-option, fieldset, .product-form__input');
      if (optionWrapper) {
        const wrapperInputs = Array.from(
          optionWrapper.querySelectorAll(
            'input[type="radio"][value], input[type="checkbox"][value]'
          )
        );
        const expectedValue =
          label.dataset.optionValue ||
          label.dataset.value ||
          label.getAttribute('data-option-value') ||
          label.getAttribute('data-value');

        if (expectedValue) {
          const matchingInput = wrapperInputs.find((candidate) => candidate.value === expectedValue);
          if (matchingInput) return matchingInput;
        }

        if (wrapperInputs.length === 1) return wrapperInputs[0];
      }

      return null;
    }

    findVariantName(label, input, labelIndex, labels) {
      const themeText = label.querySelector('.variant-option__button-label__text');
      const image = label.querySelector('img');

      const candidates = [
        label.dataset.optionValue,
        label.dataset.value,
        label.getAttribute('data-option-value'),
        label.getAttribute('data-value'),
        input ? input.dataset.optionValue : '',
        input ? input.getAttribute('data-option-value') : '',
        input ? input.value : '',
        themeText ? themeText.textContent : '',
        input ? input.getAttribute('aria-label') : '',
        label.getAttribute('aria-label'),
        label.getAttribute('title'),
      ];

      for (const candidate of candidates) {
        const cleanedName = this.cleanName(candidate);
        if (cleanedName) return cleanedName;
      }

      const fallbackName = this.findNameInProductData(label, input, labelIndex, labels);
      if (fallbackName) return fallbackName;

      const imageAlt = image ? this.cleanName(image.getAttribute('alt')) : '';
      if (imageAlt) return imageAlt;

      return '';
    }

    findNameInProductData(label, input, labelIndex, labels) {
      if (!this.optionData.length) return '';

      const group = this.findGroup(label);
      const groupText = group ? (group.textContent || '').toLowerCase() : '';
      const inputName = input ? (input.name || '').toLowerCase() : '';
      const positionValue =
        (input && (input.dataset.optionPosition || input.getAttribute('data-option-position'))) ||
        (group && (group.dataset.optionPosition || group.getAttribute('data-option-position')));
      const position = Number(positionValue || 0);

      let option = position
        ? this.optionData.find((entry) => Number(entry.position) === position)
        : null;

      if (!option && inputName) {
        option = this.optionData.find((entry) =>
          inputName.includes(String(entry.name || '').toLowerCase())
        );
      }

      if (!option && groupText) {
        option = this.optionData.find((entry) =>
          groupText.includes(String(entry.name || '').toLowerCase())
        );
      }

      if (!option) {
        const groups = [];
        labels.forEach((imageLabel) => {
          const imageGroup = this.findGroup(imageLabel);
          if (imageGroup && !groups.includes(imageGroup)) groups.push(imageGroup);
        });
        const groupIndex = groups.indexOf(group);
        if (groupIndex >= 0) option = this.optionData[groupIndex];
      }

      if (!option || !Array.isArray(option.values)) return '';

      const labelsInGroup = labels.filter((imageLabel) => this.findGroup(imageLabel) === group);
      const valueIndex = labelsInGroup.indexOf(label);

      if (valueIndex >= 0 && option.values[valueIndex]) {
        return this.cleanName(option.values[valueIndex]);
      }

      const flattenedValues = this.optionData.flatMap((entry) => entry.values || []);
      return this.cleanName(flattenedValues[labelIndex] || '');
    }

    cleanName(value) {
      if (typeof value !== 'string') return '';

      let name = value.replace(/\s+/g, ' ').trim();
      if (!name) return '';

      if (name.includes(':')) {
        name = name.slice(name.indexOf(':') + 1).trim();
      }

      name = name
        .replace(/\s*[-–—]?\s*(unavailable|sold out)$/i, '')
        .replace(/^select\s+/i, '')
        .trim();

      return name;
    }
  }

  if (!customElements.get('variant-picker-image-names')) {
    customElements.define('variant-picker-image-names', VariantPickerImageNames);
  }
  } catch(e) { console.error(e); }
})();

})();
